import * as React from 'react';
import { map } from 'rxjs/operators';
import {
  entitiesProvider,
  toGroupedSelectOptions,
} from '../../../../data/providers/entitiesProvider';
import { IOptionGroup, ISelectOption } from '../../../../data/types';
import { Select } from '../Select';

interface IProps {
  value: ISelectOption;
  disabled?: boolean;
  onChange: (s: ISelectOption) => void;
}

const PopulationSelect = (props: IProps): React.ReactElement => {
  const [options, setOptions] = React.useState<IOptionGroup[]>();
  const selfOption = {
    label: 'Self',
    options: [{ label: 'Self', value: 'self' }],
  };

  React.useEffect((): (() => void) => {
    const subscriber = entitiesProvider()
      .pipe(map(toGroupedSelectOptions))
      .subscribe((mOptions: IOptionGroup[]): void =>
        setOptions([selfOption, ...mOptions])
      );
    return (): void => subscriber.unsubscribe();
  }, []);

  return (
    <Select
      options={options}
      value={props.value}
      isDisabled={props.disabled}
      placeholder='Population...'
      onChange={props.onChange}
      id={'input-select'}
      cache
    />
  );
};

export { PopulationSelect };
